var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_nuove_assunzioni",
    "data-name": "icona nuove assunzioni",
    transform: "translate(-311 -233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_2081",
    "data-name": "Tracciato 2081",
    d: "M163.1,2.957a9.205,9.205,0,0,0-13.017,0L113.589,39.445a2.044,2.044,0,0,0-.525.9l-4.8,17.323a2.045,2.045,0,0,0,2.517,2.517l17.325-4.8a2.045,2.045,0,0,0,.9-.525L165.5,18.373a9.213,9.213,0,0,0,0-13.016ZM118.045,40.775l29.866-29.864,9.632,9.631L127.677,50.406Zm-1.924,3.86,7.7,7.7L113.172,55.28Zm46.485-29.155-2.169,2.169L150.8,8.018l2.17-2.169a5.114,5.114,0,0,1,7.231,0l2.4,2.4A5.12,5.12,0,0,1,162.606,15.481Zm0,0",
    transform: "translate(202.81 232.739)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.73fbf479acb20ff6ffe9c06213f51881.svg";
export { ForwardRef as ReactComponent };